import { i18n } from '@/plugins/i18n'
import {bankTransferTransactionStr, bankTransferTransactionVariant} from "@/constants/bankTransferTransaction";
import TransferDescriptionColumn from "@/views/openBanking/components/manage-access/transfer-description-column.vue";
import {
    bankTransferTransactionServiceType,
    bankTransferTransactionServiceTypeStr
} from "@/constants/bankTransferTransactionServiceType";

const descriptionTemplate = (row, index, datatable) => {
    let template = new TransferDescriptionColumn({
        props: {
            row,
            index,
            datatable,
        },
        i18n,
    })

    template.row = row
    template.index = index
    template.datatable = datatable

    return template.$mount().$el
}
export default [
    {
        field: 'id',
        title: '#',
        sortable: true,
        width: 30,
        type: 'number',
        textAlign: 'center',
    },
    {
        field: 'user_id',
        title: i18n.t('label.user_full_name'),
        sortable: false,
        textAlign: 'center',
        template: (row) => {
            return '<a href="/users/' + row.user_id + '/details">'+row.user_full_name+'</a>'
        },
    },
    {
        field: 'amount',
        title: `${i18n.t('label.amount')} (${i18n.t('wallets.label.rial')})`,
        sortable: true,
        textAlign: 'center',
    },
    {
        field: 'track_id',
        title: `${i18n.t('label.track_id')}  ${i18n.t('label.acceptor')}`,
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'bank_track_id',
        title: i18n.t('label.track_id'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'destination_account',
        title: i18n.t('transaction_transfer.destination_account'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'destination_full_name',
        title: i18n.t('transaction_transfer.destination_full_name'),
        sortable: false,
        textAlign: 'center',
        template: (row) => {
            let full_name = row.description.destination_full_name
            return '<div>' +  (full_name || '-') + '</div>'
        },
    },
    {
        field: 'destination_bank',
        title: i18n.t('label.destination_bank'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'type',
        title: i18n.t('open_banking.type'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'status',
        sortable: false,
        textAlign: 'center',
        title: i18n.t('label.status'),
        template: (row) => {
            let status  = bankTransferTransactionStr.get(row.status)
            let variant = bankTransferTransactionVariant(row.status)

            return '<div class="badge '+variant+' text-white">'+ status+'</div>'
        },
        width: 60
    },
    {
        field: 'service_type',
        sortable: false,
        textAlign: 'center',
        title: i18n.t('open_banking.service_type'),
        template: (row) => {
            let status  = bankTransferTransactionServiceTypeStr.get(row.service_type)
            if (row.service_type === bankTransferTransactionServiceType.PANEL) {
                return '<div class="badge badge-secondary">'+ status+'</div>'
            } else if (row.service_type === bankTransferTransactionServiceType.WEBSERVICE) {
                return '<div class="badge badge-info">'+ status+'</div>'
            } else if (row.service_type === bankTransferTransactionServiceType.GENERAL_PANEL) {
                return '<div class="badge badge-dark">'+ status+'</div>'
            } else if (row.service_type === bankTransferTransactionServiceType.SYSTEM) {
                return '<div class="badge badge-warning">'+ status+'</div>'
            } else if (row.service_type === bankTransferTransactionServiceType.REJECTION) {
                return '<div class="badge badge-danger">'+ status+'</div>'
            }
        },
        width: 60
    },

    {
        field: 'created_at',
        title: i18n.t('label.created_at'),
        sortable: true,
        width: 80,
        textAlign: 'center',
    },
    {
        field: 'description',
        width: 50,
        title: i18n.t('label.description'),
        template: (row, index, datatable) => {
            return descriptionTemplate(row, index, datatable)
        },
        sortable: false,
        textAlign: 'center',
    },
]